export default __webpack_public_path__ + "static/media/light_02.2a0fd298.svg";